import React from "react";
import ProductDetailDeepComponent from "../components/product/detailDeep";

const ProductDetailDeep = () => {
  return (
    <>
      <ProductDetailDeepComponent />
    </>
  );
};

export default ProductDetailDeep;
